module.exports = __webpack_public_path__ + "static/media/AVK01690.6fa9997c.jpg";